<template>
    <div class="card">
        <div class="card-header">
            <h3 class="card-title">Sesión del día {{ sesion ? sesion.fecha  : ''}}</h3>
            <Button v-if="paso > 1" class="float-right" @click="goTo(1)">Cambiar zona</Button>
        </div>

        <div class="card-body" v-if="!loading">
            <transition name="fade" mode="out-in">
                <div key="1" v-if="paso == 1" id="paso-1">
                    <PasoUnoComponent v-if="evento" :evento="evento" :sesion_id="sesion.id" v-on:goTo="finalizarPasoUno"></PasoUnoComponent>
                </div>
                <div key="2" v-if="paso >= 2" class="mt-3" id="paso-2">
                    <PasoDosComponent 
                        :evento="evento"
                        :zona="zona_seleccionada" 
                        :datos_compradores="datos_compradores"
                        v-on:goTo="finalizarPasoDos"
                        :recinto="recinto"
                        :entradas="entradas"
                        :puede_cambiar="puede_cambiar"
                        :dia_abonado="dia_abonado"
                        v-on:actualizarEntradas="resetPaso3"
                        :place="evento.place_obj"
                    ></PasoDosComponent>
                </div>
            </transition>
            <transition name="fade" mode="out-in">
                <div key="3" v-if="paso >= 3" class="mt-3" id="paso-3">
                    <PasoTresComponent 
                        :datos_compradores="datos_compradores"
                        :entradas_seleccionadas="entradas"
                        :solicitar_datos="evento.solicitar_datos"
                        v-on:goTo="finalizarPasoTres"
                    ></PasoTresComponent>
                </div>
            </transition>
            <transition name="fade" mode="out-in">
                <div key="4" v-if="paso >= 4" class="mt-3" id="paso-4">
                    <PasoCuatroComponent :recinto="recinto" :datos_compra="datos_compra" v-on:goTo="goTo" :email="email" :whatsapp="whatsapp" :carrito_id="carrito_id"></PasoCuatroComponent>
                </div>
            </transition>
        </div>

        <div class="card-body" v-else>
            <LoaderComponent></LoaderComponent>
        </div>
    </div>
</template>

<script>
    import LoaderComponent from '@/components/preloader/LoaderComponent';
    import PasoUnoComponent from '@/components/backend/stepper/eventos/PasoUnoComponent';
    import PasoDosComponent from '@/components/backend/stepper/eventos/PasoDosComponent';
    import PasoTresComponent from '@/components/backend/stepper/eventos/PasoTresComponent';
    import PasoCuatroComponent from '@/components/backend/stepper/eventos/PasoCuatroComponent';

    export default {
        props: ['evento', 'sesion'],
        data() {
            return {
                loading: false,
                paso: 1,
                zona_seleccionada: null,
                zonas: null,
                datos_compradores: [],
                datos_compra: null,
                entradas_seleccionadas: null,
                entradas: [],
                email: null,
                whatsapp: null,
                puede_cambiar: true,
                dia_abonado: false,
                carrito_id: null
            }
        },
        created() {
            this.entradas = this.evento.entradas;
            for(var i in this.evento.entradas) {
                this.entradas[i].unidades = 0;
            }
            if(!this.evento.tiene_recinto) {
                this.finalizarPasoDos(2, null);
            }
        },
        computed: {
            recinto() {
                if(!this.evento) {
                    return null;
                }

                if(this.evento.tiene_recinto) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        methods: {
            resetPaso3() {
                if(this.paso >= 3) {
                    this.paso = 2;
                    this.$nextTick(function() {
                        this.paso = 3;
                    });
                }                
            },
            scrollTo (paso) {
                this.$scrollTo(paso, 100)
            },
            goTo (paso) {
                if(paso < this.paso) {
                    if(paso == 1) {
                        this.entradas = [];
                        this.entradas_seleccionadas = null;
                        this.datos_compra = null;
                        this.zona_seleccionada = null;
                        this.datos_compradores = [];
                        this.entradas_seleccionadas = null;
                    }
                    if(paso == 2) {
                        this.paso = 1;
                        this.entradas = [];
                        this.entradas_seleccionadas = null;
                        this.datos_compra = null;
                        this.datos_compradores = [];
                        this.entradas_seleccionadas = null;

                        if(!this.evento.tiene_recinto) {
                            this.getEvento();
                        }
                    }

                    this.$nextTick(function() {
                        this.paso = paso;
                    });
                }
            },
            finalizarPasoUno(paso, zona, data) {
                if(data.dia_abonado) {
                    this.dia_abonado = true;
                    this.datos_compradores.push(data.datos_compradores);
                    this.entradas = data.entradas;
                }

                this.puede_cambiar = data.puede_cambiar;

                if(paso >= 2) {
                    this.zona_seleccionada = zona;
                }

                this.paso = paso;

                this.$nextTick(function() {
                    this.scrollTo('#paso-' + paso);
                });
            },
            finalizarPasoDos(paso, datos, carrito_id) {
                if(carrito_id) {
                    this.carrito_id = carrito_id;
                }

                if(datos) {
                    this.datos_compradores = datos;
                }

                if(Array.isArray(this.entradas) && this.entradas.length > 0) {
                    for (var i = 0; i < this.entradas.length; i++) {
                        if(this.entradas[i].unidades > 0) {
                            for (var x = 0; x < this.entradas[i].unidades; x++) {
                                this.datos_compradores.push({
                                    apellidos: '',
                                    asiento: {
                                        zona_nombre: 'General'
                                    },
                                    descuento: 0,
                                    dni: '',
                                    es_nuevo: true,
                                    nombre: '',
                                    precio: {
                                        descripcion: this.entradas[i].name,
                                        gd: this.entradas[i].price_management,
                                        gd_interno: this.entradas[i].price_management_interno,
                                        price_management_taquilla: this.entradas[i].price_management,
                                        id: this.entradas[i].id,
                                        precio: this.entradas[i].price,
                                        precio_total: this.entradas[i].total_price
                                    },
                                    precios: [
                                        {
                                            descripcion: this.entradas[i].name,
                                            gd: this.entradas[i].price_management,
                                            gd_interno: this.entradas[i].price_management_interno,
                                            id: this.entradas[i].id,
                                            precio: this.entradas[i].price,
                                            price_management_taquilla: this.entradas[i].price_management,
                                            precio_total: this.entradas[i].total_price
                                        }
                                    ],
                                    telefono: '',
                                    url_imprimir: null
                                });
                            }
                        }
                    }
                }

                this.paso = paso;

                this.$nextTick(function() {
                    this.scrollTo('#paso-' + paso);
                });
            },
            finalizarPasoTres (paso, datos, email, whatsapp) {
                this.email = email;
                this.whatsapp = whatsapp;
                var datos_compra = null
                if(this.zona_seleccionada != null) {
                    datos_compra = {
                        evento_id : this.evento.id,
                        sesion_id : this.sesion.id,
                        zona_id : this.zona_seleccionada.id,
                        datos_compradores : this.datos_compradores,
                        metodo_pago : datos.metodo_pago,
                        modalidad : 0,
                        tipo : false,
                        concepto : datos.concepto,
                        enviar_email : datos.enviar_email,
                        email : datos.email,
                        nombre : datos.nombre,
                        telefono : datos.telefono,
                        enviar_whatsapp : datos.enviar_whatsapp,
                        cp: datos.cp,
                        recinto: true
                    };
                } else {
                    datos_compra = {
                        evento_id : this.evento.id,
                        sesion_id : this.sesion.id,
                        zona_id : 1,
                        datos_compradores : this.datos_compradores,
                        entradas : this.entradas,
                        metodo_pago : datos.metodo_pago,
                        modalidad : 0,
                        tipo : false,
                        concepto : datos.concepto,
                        enviar_email : datos.enviar_email,
                        email : datos.email,
                        nombre : datos.nombre,
                        telefono : datos.telefono,
                        enviar_whatsapp : datos.enviar_whatsapp,
                        cp: datos.cp,
                        recinto: false
                    };
                }
                if(datos) {
                    this.datos_compra = datos_compra;
                }
                this.paso = paso;

                this.$nextTick(function() {
                    this.scrollTo('#paso-' + paso);
                });
            }
        },
        components: {
            LoaderComponent, PasoUnoComponent, PasoDosComponent, PasoTresComponent, PasoCuatroComponent
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
